import { useAuthenticatedSession } from '../../session/SessionProvider.js';
import { tsr } from '../../lib/api.js';
import { PollVote, SURVEY_QUERY_KEY } from '../../features/surveys/surveyShared.js';
import { HomeCard } from './HomeCard.js';

/**
 * The newest open poll, answered right here with the tally shown after voting (ADR 0027). Renders
 * nothing when there is no open poll, so Home does not grow an empty card.
 */
export function QuickPollCard() {
  const { permissions } = useAuthenticatedSession();
  const allowed = permissions.has('survey:read');
  const query = tsr.surveys.listMySurveys.useQuery({
    queryKey: [...SURVEY_QUERY_KEY, 'mine', 'polls'],
    queryData: { query: { kind: 'poll' } },
    enabled: allowed,
  });
  const polls = query.data?.status === 200 ? query.data.body.items : [];
  // Unanswered first, so the card asks before it reports.
  const poll = polls.find((p) => !p.completedAt) ?? polls[0];
  if (!allowed || !poll) return null;

  return (
    <HomeCard title="Quick poll" viewAll={{ to: '/engage/surveys', label: 'All surveys' }}>
      <PollVote key={poll.id} poll={poll} />
    </HomeCard>
  );
}
